var map = {
	"./fonts/Poppins-Bold.eot": "29c6",
	"./fonts/Poppins-Bold.ttf": "0c3c",
	"./fonts/Poppins-Bold.woff": "5e82",
	"./fonts/Poppins-Bold.woff2": "e2bd",
	"./fonts/Poppins-Light.eot": "322d",
	"./fonts/Poppins-Light.ttf": "4fc1",
	"./fonts/Poppins-Light.woff": "bc13",
	"./fonts/Poppins-Light.woff2": "6a9e",
	"./fonts/Poppins-Medium.eot": "5851",
	"./fonts/Poppins-Medium.ttf": "4962",
	"./fonts/Poppins-Medium.woff": "cfff",
	"./fonts/Poppins-Medium.woff2": "42c5",
	"./fonts/Poppins-Regular.eot": "159f",
	"./fonts/Poppins-Regular.ttf": "e9f5",
	"./fonts/Poppins-Regular.woff": "9360",
	"./fonts/Poppins-Regular.woff2": "03668",
	"./fonts/Poppins-SemiBold.eot": "699a",
	"./fonts/Poppins-SemiBold.ttf": "56a7",
	"./fonts/Poppins-SemiBold.woff": "e0f4",
	"./fonts/Poppins-SemiBold.woff2": "6296",
	"./fonts/Sen-Bold.eot": "ac86",
	"./fonts/Sen-Bold.ttf": "0ca8",
	"./fonts/Sen-Bold.woff": "1a55",
	"./fonts/Sen-Bold.woff2": "44dc",
	"./fonts/Sen-Regular.eot": "db29",
	"./fonts/Sen-Regular.ttf": "9e20",
	"./fonts/Sen-Regular.woff": "2a17",
	"./fonts/Sen-Regular.woff2": "4fd5",
	"./png/default-avatar.png": "95c3",
	"./png/home/bg-game.png": "daf1",
	"./png/home/bg-step.png": "ca03",
	"./png/home/bg-tell.png": "3911",
	"./png/languages/en.png": "29b7",
	"./png/languages/ru.png": "9778",
	"./png/leaderboard-empty.png": "dc30",
	"./png/menu/bg-about.png": "c421",
	"./png/menu/bg-referrals.png": "8a54",
	"./png/rectangle-menu.png": "e95e",
	"./png/sign-up/discord.png": "f99f",
	"./png/sign-up/google.png": "eebc",
	"./png/sign-up/twitch.png": "f519",
	"./png/slider/background.png": "c519",
	"./png/tournaments/tournaments-default.png": "af4f",
	"./png/wifi-off.png": "713f",
	"./png/wifi-on.png": "2839",
	"./svg/404/404.svg": "97bc",
	"./svg/arrow-left.svg": "f6db",
	"./svg/arrow-right.svg": "8281",
	"./svg/audiobook.svg": "004f",
	"./svg/calendar.svg": "76b2",
	"./svg/checked-symbol.svg": "5957",
	"./svg/close-white.svg": "689c",
	"./svg/close.svg": "bb7c",
	"./svg/copy.svg": "b420",
	"./svg/dashboard-cards/accuracy.svg": "76db",
	"./svg/dashboard-cards/assists.svg": "b62a",
	"./svg/dashboard-cards/crowd.svg": "b2a8",
	"./svg/dashboard-cards/deaths.svg": "2548",
	"./svg/dashboard-cards/denies.svg": "b35a",
	"./svg/dashboard-cards/earnings.svg": "1c33",
	"./svg/dashboard-cards/gold.svg": "3435",
	"./svg/dashboard-cards/headshot-kills.svg": "2527",
	"./svg/dashboard-cards/kills.svg": "a7cb",
	"./svg/dashboard-cards/lvl.svg": "5a1a",
	"./svg/dashboard-cards/matches.svg": "2ff8",
	"./svg/dashboard-cards/money.svg": "5882",
	"./svg/dashboard-cards/rank.svg": "2849",
	"./svg/dashboard-cards/ratio.svg": "7e92",
	"./svg/dashboard-cards/top.svg": "c77a",
	"./svg/dashboard-cards/trophy.svg": "aea0",
	"./svg/dashboard-cards/watch.svg": "53be",
	"./svg/dashboard-cards/winrate.svg": "c4b9",
	"./svg/dashboard-cards/wins.svg": "fe4e",
	"./svg/delete.svg": "571d",
	"./svg/deposit.svg": "85c9",
	"./svg/dollar.svg": "c667",
	"./svg/down-arrow.svg": "e094",
	"./svg/facebook.svg": "7e4b",
	"./svg/failed.svg": "1ad9",
	"./svg/home/line-dotted.svg": "acfa",
	"./svg/home/logo-big.svg": "ba7f",
	"./svg/idea-active.svg": "9349",
	"./svg/idea.svg": "a62c",
	"./svg/info.svg": "69d9",
	"./svg/leaderbaord-yellow.svg": "a3c3",
	"./svg/logo-footer.svg": "1cbd",
	"./svg/logout.svg": "a861",
	"./svg/medium.svg": "eb09",
	"./svg/menu/dashboard-active.svg": "87d5",
	"./svg/menu/dashboard.svg": "260b",
	"./svg/menu/dot-active.svg": "c79c",
	"./svg/menu/dot.svg": "5b56",
	"./svg/menu/ellipsis-active.svg": "a0a1",
	"./svg/menu/ellipsis.svg": "d541",
	"./svg/menu/header.svg": "8168",
	"./svg/menu/leadboard-active.svg": "2962",
	"./svg/menu/leadboard.svg": "5074",
	"./svg/menu/logo.svg": "8cca",
	"./svg/menu/referrals-active.svg": "6b51",
	"./svg/menu/referrals.svg": "5b35",
	"./svg/menu/settings-active.svg": "fec3",
	"./svg/menu/settings.svg": "e7de",
	"./svg/menu/tournaments-active.svg": "b0c5",
	"./svg/menu/tournaments.svg": "5e8a",
	"./svg/menu/wallet-active.svg": "0dfd",
	"./svg/menu/wallet.svg": "7269",
	"./svg/pay-per.svg": "a0c3",
	"./svg/pending.svg": "4902",
	"./svg/play.svg": "af53",
	"./svg/price-icon.svg": "24da",
	"./svg/referrals/clicks.svg": "b65a",
	"./svg/referrals/earnings.svg": "6f68",
	"./svg/referrals/facebook.svg": "1d47",
	"./svg/referrals/info-bg.svg": "b421",
	"./svg/referrals/reddit.svg": "6b73",
	"./svg/referrals/registrations.svg": "2cac",
	"./svg/referrals/twitter.svg": "3368",
	"./svg/referrals/uniqueClicks.svg": "d621",
	"./svg/refresh.svg": "d47a",
	"./svg/shape-round.svg": "3471",
	"./svg/sprite/flag-afghanistan.svg": "3ce2",
	"./svg/sprite/flag-aland-islands.svg": "c86e",
	"./svg/sprite/flag-albania.svg": "7d97",
	"./svg/sprite/flag-algeria.svg": "ae45",
	"./svg/sprite/flag-american-samoa.svg": "5155",
	"./svg/sprite/flag-andorra.svg": "080f",
	"./svg/sprite/flag-angola.svg": "f1b4",
	"./svg/sprite/flag-anguilla.svg": "f06c",
	"./svg/sprite/flag-antigua-and-barbuda.svg": "a360",
	"./svg/sprite/flag-argentina.svg": "e8e6",
	"./svg/sprite/flag-armenia.svg": "d940",
	"./svg/sprite/flag-aruba.svg": "cdac",
	"./svg/sprite/flag-australia.svg": "25de",
	"./svg/sprite/flag-austria.svg": "095d",
	"./svg/sprite/flag-azerbaijan.svg": "cfb4",
	"./svg/sprite/flag-bahamas.svg": "7e11",
	"./svg/sprite/flag-bahrain.svg": "c03c",
	"./svg/sprite/flag-bangladesh.svg": "15db",
	"./svg/sprite/flag-barbados.svg": "c28b",
	"./svg/sprite/flag-belarus.svg": "1359",
	"./svg/sprite/flag-belgium.svg": "f5fd",
	"./svg/sprite/flag-belize.svg": "d114",
	"./svg/sprite/flag-benin.svg": "ff40",
	"./svg/sprite/flag-bermuda.svg": "2277",
	"./svg/sprite/flag-bhutan.svg": "cdaa",
	"./svg/sprite/flag-bolivia.svg": "2a33",
	"./svg/sprite/flag-bosnia-and-herzegovina.svg": "a4fb",
	"./svg/sprite/flag-botswana.svg": "c9e7",
	"./svg/sprite/flag-brazil.svg": "6fdf",
	"./svg/sprite/flag-british-indian-ocean-territory.svg": "2284",
	"./svg/sprite/flag-brunei-darussalam.svg": "c3a6",
	"./svg/sprite/flag-bulgaria.svg": "a3b5",
	"./svg/sprite/flag-burkina-faso.svg": "7add",
	"./svg/sprite/flag-burundi.svg": "16e5",
	"./svg/sprite/flag-cambodia.svg": "13b3",
	"./svg/sprite/flag-cameroon.svg": "c6de",
	"./svg/sprite/flag-canada.svg": "d908",
	"./svg/sprite/flag-cape-verde.svg": "0809",
	"./svg/sprite/flag-cayman-islands.svg": "5a04",
	"./svg/sprite/flag-central-african-republic.svg": "0a3e",
	"./svg/sprite/flag-chad.svg": "fc3b",
	"./svg/sprite/flag-chile.svg": "c908",
	"./svg/sprite/flag-china.svg": "c3f4",
	"./svg/sprite/flag-christmas-island.svg": "fe59",
	"./svg/sprite/flag-cocos-islands.svg": "83f9",
	"./svg/sprite/flag-colombia.svg": "59b2",
	"./svg/sprite/flag-comoros.svg": "19f0",
	"./svg/sprite/flag-cook-islands.svg": "09a5",
	"./svg/sprite/flag-costa-rica.svg": "17e9",
	"./svg/sprite/flag-croatia.svg": "6e34",
	"./svg/sprite/flag-cuba.svg": "2c73",
	"./svg/sprite/flag-cyprus.svg": "ab1a",
	"./svg/sprite/flag-czech-republic.svg": "2ad9",
	"./svg/sprite/flag-denmark.svg": "978c",
	"./svg/sprite/flag-djibouti.svg": "83d6",
	"./svg/sprite/flag-dominica.svg": "de81",
	"./svg/sprite/flag-dominican-republic.svg": "0b58",
	"./svg/sprite/flag-ecuador.svg": "92f9",
	"./svg/sprite/flag-egypt.svg": "377c",
	"./svg/sprite/flag-el-salvador.svg": "2cd5",
	"./svg/sprite/flag-england.svg": "1bdc",
	"./svg/sprite/flag-equatorial-guinea.svg": "6122",
	"./svg/sprite/flag-eritrea.svg": "8c83",
	"./svg/sprite/flag-estonia.svg": "4615",
	"./svg/sprite/flag-ethiopia.svg": "6870",
	"./svg/sprite/flag-falkland-islands.svg": "1dcf",
	"./svg/sprite/flag-faroe-islands.svg": "983b",
	"./svg/sprite/flag-fiji.svg": "4740",
	"./svg/sprite/flag-finland.svg": "6209",
	"./svg/sprite/flag-france.svg": "912e",
	"./svg/sprite/flag-french-polynesia.svg": "d56e",
	"./svg/sprite/flag-gabon.svg": "2504",
	"./svg/sprite/flag-galapagos-islands.svg": "176c",
	"./svg/sprite/flag-gambia.svg": "aee3",
	"./svg/sprite/flag-georgia.svg": "da48",
	"./svg/sprite/flag-germany.svg": "f5fe",
	"./svg/sprite/flag-ghana.svg": "c21f",
	"./svg/sprite/flag-gibraltar.svg": "8f34",
	"./svg/sprite/flag-greece.svg": "f0a9",
	"./svg/sprite/flag-greenland.svg": "a535",
	"./svg/sprite/flag-grenada.svg": "fdac",
	"./svg/sprite/flag-guam.svg": "e6d4",
	"./svg/sprite/flag-guatemala.svg": "0a85",
	"./svg/sprite/flag-guernsey.svg": "d774",
	"./svg/sprite/flag-guinea-bissau.svg": "1f3e",
	"./svg/sprite/flag-guinea.svg": "d1ff",
	"./svg/sprite/flag-haiti.svg": "2616",
	"./svg/sprite/flag-honduras.svg": "5055",
	"./svg/sprite/flag-hong-kong.svg": "14d0",
	"./svg/sprite/flag-hungary.svg": "fb27",
	"./svg/sprite/flag-iceland.svg": "7b1a",
	"./svg/sprite/flag-india.svg": "72fb",
	"./svg/sprite/flag-indonesia.svg": "318a",
	"./svg/sprite/flag-iran.svg": "718f",
	"./svg/sprite/flag-iraq.svg": "dce7",
	"./svg/sprite/flag-ireland.svg": "028a",
	"./svg/sprite/flag-isle-of-man.svg": "8b93",
	"./svg/sprite/flag-israel.svg": "af66",
	"./svg/sprite/flag-italy.svg": "ca15",
	"./svg/sprite/flag-jamaica.svg": "845e",
	"./svg/sprite/flag-japan.svg": "34ef",
	"./svg/sprite/flag-jersey.svg": "c361",
	"./svg/sprite/flag-jordan.svg": "501b",
	"./svg/sprite/flag-kazakhstan.svg": "c47b",
	"./svg/sprite/flag-kenya.svg": "1220",
	"./svg/sprite/flag-kuwait.svg": "f907",
	"./svg/sprite/flag-kyrgyzstan.svg": "4d8a",
	"./svg/sprite/flag-lao-democratic-republic.svg": "ffac",
	"./svg/sprite/flag-latvia.svg": "38f9",
	"./svg/sprite/flag-lebanon.svg": "ffe7",
	"./svg/sprite/flag-lesotho.svg": "61fe",
	"./svg/sprite/flag-liberia.svg": "50ba",
	"./svg/sprite/flag-libyan-arab-jamahiriya.svg": "24c9",
	"./svg/sprite/flag-liechtenstein.svg": "1a94",
	"./svg/sprite/flag-lithuania.svg": "8a6a",
	"./svg/sprite/flag-luxembourg.svg": "d6be",
	"./svg/sprite/flag-macao.svg": "0fd2",
	"./svg/sprite/flag-madagascar.svg": "8ff7",
	"./svg/sprite/flag-malawi.svg": "20aa",
	"./svg/sprite/flag-malaysia.svg": "f2cc",
	"./svg/sprite/flag-maldives.svg": "c825",
	"./svg/sprite/flag-mali.svg": "369b",
	"./svg/sprite/flag-malta.svg": "0ecd",
	"./svg/sprite/flag-marshall-islands.svg": "41b3",
	"./svg/sprite/flag-martinique.svg": "1107",
	"./svg/sprite/flag-mauritania.svg": "b141",
	"./svg/sprite/flag-mauritius.svg": "ab01",
	"./svg/sprite/flag-mexico.svg": "7803",
	"./svg/sprite/flag-micronesia.svg": "0204",
	"./svg/sprite/flag-moldova.svg": "fd9a",
	"./svg/sprite/flag-monaco.svg": "26da",
	"./svg/sprite/flag-mongolia.svg": "15bc",
	"./svg/sprite/flag-montserrat.svg": "3ebd",
	"./svg/sprite/flag-morocco.svg": "8eff",
	"./svg/sprite/flag-mozambique.svg": "d9be",
	"./svg/sprite/flag-myanmar.svg": "a067",
	"./svg/sprite/flag-namibia.svg": "c1bf",
	"./svg/sprite/flag-nauru.svg": "1493",
	"./svg/sprite/flag-nepal.svg": "0337",
	"./svg/sprite/flag-netherlands.svg": "d901",
	"./svg/sprite/flag-new-zealand.svg": "b5db",
	"./svg/sprite/flag-nicaragua.svg": "57e9",
	"./svg/sprite/flag-niger.svg": "c240",
	"./svg/sprite/flag-nigeria.svg": "ae27",
	"./svg/sprite/flag-niue.svg": "7e83",
	"./svg/sprite/flag-norfolk-island.svg": "7dd8",
	"./svg/sprite/flag-north-korea.svg": "3955",
	"./svg/sprite/flag-northen-cyprus.svg": "9f34",
	"./svg/sprite/flag-northern-mariana-islands.svg": "81f6",
	"./svg/sprite/flag-norway.svg": "8079",
	"./svg/sprite/flag-oman.svg": "c01f",
	"./svg/sprite/flag-pakistan.svg": "bfad",
	"./svg/sprite/flag-palau.svg": "570c",
	"./svg/sprite/flag-palestinian-territory.svg": "78d1",
	"./svg/sprite/flag-panama.svg": "193c",
	"./svg/sprite/flag-papua-new-guinea.svg": "38db",
	"./svg/sprite/flag-paraguay.svg": "a9e7",
	"./svg/sprite/flag-peru.svg": "fc9a",
	"./svg/sprite/flag-philippines.svg": "3e44",
	"./svg/sprite/flag-pitcairn.svg": "251a",
	"./svg/sprite/flag-poland.svg": "c53c",
	"./svg/sprite/flag-portugal.svg": "d7749",
	"./svg/sprite/flag-puerto-rico.svg": "4564",
	"./svg/sprite/flag-qatar.svg": "cf82",
	"./svg/sprite/flag-romania.svg": "21ef",
	"./svg/sprite/flag-russian-federation.svg": "f79a",
	"./svg/sprite/flag-rwanda.svg": "27ec",
	"./svg/sprite/flag-saint-kitts-and-nevis.svg": "95b1",
	"./svg/sprite/flag-samoa.svg": "796a",
	"./svg/sprite/flag-san-marino.svg": "d85d",
	"./svg/sprite/flag-sao-tome-and-principe.svg": "7a22",
	"./svg/sprite/flag-saudi-arabia.svg": "c58e",
	"./svg/sprite/flag-senegal.svg": "95fe",
	"./svg/sprite/flag-serbia.svg": "657d",
	"./svg/sprite/flag-seychelles.svg": "5f6c",
	"./svg/sprite/flag-sierra-leone.svg": "db83",
	"./svg/sprite/flag-singapore.svg": "0293",
	"./svg/sprite/flag-slovakia.svg": "9e69",
	"./svg/sprite/flag-slovenia.svg": "a141",
	"./svg/sprite/flag-solomon-islands.svg": "9ee9",
	"./svg/sprite/flag-somalia.svg": "71ba",
	"./svg/sprite/flag-south-africa.svg": "5fc3",
	"./svg/sprite/flag-spain.svg": "2b1f",
	"./svg/sprite/flag-sri-lanka.svg": "2a66",
	"./svg/sprite/flag-sudan.svg": "1391",
	"./svg/sprite/flag-suriname.svg": "a0f7",
	"./svg/sprite/flag-sweden.svg": "a403",
	"./svg/sprite/flag-switzerland.svg": "aaca",
	"./svg/sprite/flag-syrian-arab-republic.svg": "2dd2",
	"./svg/sprite/flag-taiwan.svg": "a511",
	"./svg/sprite/flag-tajikistan.svg": "498c",
	"./svg/sprite/flag-tanzania.svg": "f6ce",
	"./svg/sprite/flag-thailand.svg": "ba65",
	"./svg/sprite/flag-togo.svg": "3f68",
	"./svg/sprite/flag-tokelau.svg": "6756",
	"./svg/sprite/flag-tonga.svg": "dfff",
	"./svg/sprite/flag-trinidad-and-tobago.svg": "06ae",
	"./svg/sprite/flag-tunisia.svg": "b283",
	"./svg/sprite/flag-turkey.svg": "6cdb",
	"./svg/sprite/flag-turkmenistan.svg": "3fde",
	"./svg/sprite/flag-turks-and-caicos-islands.svg": "d1e4",
	"./svg/sprite/flag-tuvalu.svg": "b988",
	"./svg/sprite/flag-uganda.svg": "bead",
	"./svg/sprite/flag-ukraine.svg": "5f01",
	"./svg/sprite/flag-united-arab-emirates.svg": "3e41",
	"./svg/sprite/flag-united-kingdom.svg": "91b0",
	"./svg/sprite/flag-united-nations.svg": "8a90",
	"./svg/sprite/flag-united-states-of-america.svg": "1e7c",
	"./svg/sprite/flag-uruguay.svg": "6ad3",
	"./svg/sprite/flag-uzbekistan.svg": "2502",
	"./svg/sprite/flag-vanuatu.svg": "2e86",
	"./svg/sprite/flag-venezuela.svg": "35d6",
	"./svg/sprite/flag-viet-nam.svg": "4c17",
	"./svg/sprite/flag-virgin-islands.svg": "c134",
	"./svg/sprite/flag-yemen.svg": "faa6",
	"./svg/sprite/flag-zambia.svg": "7b23",
	"./svg/sprite/flag-zimbabwe.svg": "e61a",
	"./svg/statistics.svg": "f6ba",
	"./svg/support.svg": "b0d4",
	"./svg/triangle-white.svg": "f707",
	"./svg/triangle-yellow.svg": "d3bb",
	"./svg/twitter.svg": "5a0b",
	"./svg/upload-avatar/upload-photo.svg": "feb2",
	"./svg/withdraw.svg": "23f5",
	"./svg/zoom-in.svg": "64d0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";